import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=31fe7bd1&scoped=true&"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBanner.vue?vue&type=style&index=0&id=31fe7bd1&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fe7bd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fe7bd1')) {
      api.createRecord('31fe7bd1', component.options)
    } else {
      api.reload('31fe7bd1', component.options)
    }
    module.hot.accept("./AnnouncementBanner.vue?vue&type=template&id=31fe7bd1&scoped=true&", function () {
      api.rerender('31fe7bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/App/AnnouncementBanner.vue"
export default component.exports